import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const PlayerUpgradeTool = React.lazy(() => import("@kaltura/mediaspace-shared-player-upgrade-tool"));

export const render = getStandaloneComponentRenderer(PlayerUpgradeTool);
